var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShowPassword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 11,
    viewBox: "0 0 18 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#464646",
    fillRule: "nonzero",
    d: "M15.903 5.044a16.068 16.068 0 0 0-1.701-1.591C12.44 2.032 10.597 1.19 8.78 1.19c-1.817 0-3.66.842-5.422 2.263-.705.569-1.36 1.197-1.959 1.877.6.68 1.255 1.308 1.96 1.877C5.119 8.628 6.963 9.47 8.78 9.47c1.817 0 3.66-.842 5.422-2.263.705-.569 1.36-1.197 1.959-1.877-.08-.091-.166-.186-.258-.286zM8.78 10.16C4.207 10.16.5 5.33.5 5.33S4.207.5 8.78.5c4.573 0 8.28 4.83 8.28 4.83s-3.707 4.83-8.28 4.83zm0-1.725a3.105 3.105 0 1 0 0-6.21 3.105 3.105 0 0 0 0 6.21zm0-.69a2.415 2.415 0 1 1 0-4.83 2.415 2.415 0 0 1 0 4.83z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowPassword);
export default __webpack_public_path__ + "static/media/show-password.8ff5921ca4fbd35949a72dcfe70b87aa.svg";
export { ForwardRef as ReactComponent };